/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../../common";
import type {
  RewardFeeder,
  RewardFeederInterface,
} from "../../contracts/RewardFeeder";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IStakingTierManager",
        name: "_stakingTierManager",
        type: "address",
      },
      {
        internalType: "address",
        name: "owner_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "MathOverflowedMulDiv",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "OwnableInvalidOwner",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "percentage",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "oneHundredPercent",
        type: "uint256",
      },
    ],
    name: "RewardFeeder_PercentageTooLarge",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tierLevel",
        type: "uint256",
      },
    ],
    name: "RewardFeeder_TierNotDefined",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tierLevel",
        type: "uint256",
      },
    ],
    name: "TierRewardsRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tierLevel",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "rewardAPY",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tierMultiplier",
        type: "uint256",
      },
    ],
    name: "TierRewardsSet",
    type: "event",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "getRewardAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "getRewardParams",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "rewardAPY",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tierMultiplier",
            type: "uint256",
          },
        ],
        internalType: "struct IRewardFeeder.RewardData",
        name: "params",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tierLevel",
        type: "uint256",
      },
    ],
    name: "removeTierRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IStakingTierManager",
        name: "_stakingTierManager",
        type: "address",
      },
    ],
    name: "setStakingTierManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tierLevel",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "rewardAPY",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tierMultiplier",
            type: "uint256",
          },
        ],
        internalType: "struct IRewardFeeder.RewardData",
        name: "params",
        type: "tuple",
      },
    ],
    name: "setTierRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "stakingTierManager",
    outputs: [
      {
        internalType: "contract IStakingTierManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tierToRewardParams",
    outputs: [
      {
        internalType: "bool",
        name: "defined",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "rewardAPY",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tierMultiplier",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type RewardFeederConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: RewardFeederConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class RewardFeeder__factory extends ContractFactory {
  constructor(...args: RewardFeederConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    _stakingTierManager: AddressLike,
    owner_: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(
      _stakingTierManager,
      owner_,
      overrides || {}
    );
  }
  override deploy(
    _stakingTierManager: AddressLike,
    owner_: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(
      _stakingTierManager,
      owner_,
      overrides || {}
    ) as Promise<
      RewardFeeder & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): RewardFeeder__factory {
    return super.connect(runner) as RewardFeeder__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RewardFeederInterface {
    return new Interface(_abi) as RewardFeederInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): RewardFeeder {
    return new Contract(address, _abi, runner) as unknown as RewardFeeder;
  }
}
